module.exports = __webpack_public_path__ + "static/media/activated.d5197e2a.webp";